import { i18n } from '@/commons/utils';
import { getParameters } from '../customer-utils';

const URL = {
  SEND_VERIFICATION_CODE: 'rest/model/atg/userprofiling/ProfileActor/sendVerificationCodeUpdate',
  SEND_MOBILE: 'rest/model/atg/userprofiling/ProfileActor/updateLoginInformation-mobileValidation'
};

let modal;
let countdown;


const setRules = form => {
  $(form).validate(Object.assign(
    $.validator.cubeOptions,
    {
      rules: {
        mobile: { mobile: true }
      }
    }
  ));
};


/**
 * Display an error if the XHR returns error(s).
 *
 * @param {Json} response The XHR response.
 * @param {HTMLElement} button The form submit button.
 * @returns {Boolean}
 */
const ajaxError = (response, button) => {
  if (
    typeof response === 'string' ||
    typeof response === 'object' && response.responseTO && response.responseTO.errors[0] && response.responseTO.errors[0].message
  ) {
    if (response === 'string')
      cube.alert.error(i18n('error.oc.call'));
    else
      cube.alert.error(response.responseTO.errors[0].message);

    button.disabled = false;

    return true;
  }

  return false;
};


/**
 * Display the mobile validation input.
 * Mobile verification must be activated
 *
 */
const showMobileValidation = () => {
  const validation = cube.$id('mobile-verification');

  validation.classList.remove('hidden');
  cube.alert.information(i18n('profile.smsSent'));
  countdown.go();
};


/**
 * Add the customer mobile number to his profile when the form is submitted.
 * Mobile number can be verified before the form submission.
 *
 * @param {Event} event
 */
function addMobile (event) {
  event.preventDefault();

  const form = this;
  const parameters = getParameters(form);
  const button = cube.$id('check-mobile');
  const { verificationCode: verified } = parameters;

  if ($(form).valid()) {
    button.disabled = true;

    cube.ajax
      .post(
        verified ? URL.SEND_MOBILE : URL.SEND_VERIFICATION_CODE,
        parameters
      )
      .onSuccess(response => {
        if (ajaxError(response, button))
          return;

        button.disabled = false;

        if (!verified && form.hasAttribute('data-with-validation-code'))
          showMobileValidation();
        else
          modal.modal('hide');
      })
      .onError(response => ajaxError(response, button))
      .call();
  }
};


/**
 * Do something when the modal is closed.
 *
 * @param {Function} callback the function to execute when the modal is closed.
*/
const onClose = callback => {
  const button = cube.$('.sign-in-button');

  button.disabled = false;
  callback();

  if (countdown)
    countdown.stop();
};


/**
 * Send a new validation code and display a message if the XHR returns no error.
 *
 * @param {Json} response The XHR response.
 */
const resendCodeSuccess = (response) => {
  if (ajaxError(response))
    return;

  countdown.go();
  cube.alert.information(i18n('profile.smsSent'));
};


/**
 * Call an API to resend a SMS validation code.
 *
 * @param {Event} event
 */
function resendCode (event) {
  event.preventDefault();

  const form = this.closest('form');
  const parameters = getParameters(form);

  cube.ajax
    .post(URL.SEND_VERIFICATION_CODE, parameters)
    .onSuccess(response => resendCodeSuccess(response, this))
    .onError(response => ajaxError(response))
    .call();
};


export const init = (isClosable, callback) => {
  const form = cube.$id('mobile-modal-form');
  const resendCodeButton = $(cube.$id('resend-code'));
  modal = $('#modal-phone-verification');

  setRules(form);

  if (isClosable)
    modal.modal('show');
  else
    modal
      .addClass('login-modal--not-closable')
      .modal({ show: true, backdrop: 'static', keyboard: false });

  if (resendCodeButton.length) {
    resendCodeButton.data(
      'countdown',
      new window.decathlon.userAccount.Countdown(resendCodeButton, 30)
    );

    countdown = resendCodeButton.data('countdown');
    resendCodeButton.on('click', resendCode);
  }

  form.on('submit', addMobile);
  modal.on('hidden.bs.modal', () => onClose(callback));
};


// WEBPACK FOOTER //
// ./src/customer/authentication/authentication-phone-verification.js